import { USERNAME } from "@/mk2/helpers/urls";
import { PAGE_SLUG } from "@/mk/autogenerated/translations/urls.2f99b3c69c1be98699aa952488768c7a";

const CATEGORY = ":category([a-z\\d_\\-]+)";
const PRODUCT_HASH = ":hash([0-9a-z]+)";
const PRODUCT_SLUG = ":title([0-9a-z\\d_\\-]+)";

const filterParams = `:category([a-z\\d_-]+)?/:filters([\\w-]+)?/:page(${PAGE_SLUG}-\\d+)?/`;

export const bazaarUrl = `/market/`;
export const bazaarSellerSearchUrl = `/market/seller/search/`;
export const bazaarSellerUrl = `/market/seller/${USERNAME}/`;
export const bazaarSellerBazaarUrl = `/market/seller/${USERNAME}/${filterParams}`;
export const bazaarSellerReviewsFromBuyersUrl = `/market/seller/${USERNAME}/reviews/`;
export const bazaarSellerReviewsFromSellersUrl = `/market/seller/${USERNAME}/reviews-from-sellers/`;
export const bazaarMyBazaarUrl = `/market/my_bazaar/${USERNAME}/${filterParams}`;
export const bazaarMyReviewsFromBuyersUrl = `/market/my_bazaar/${USERNAME}/reviews/`;
export const bazaarMyReviewsFromSellersUrl = `/market/my_bazaar/${USERNAME}/reviews-from-sellers/`;
export const bazaarMyWidgetUrl = `/market/my_bazaar/${USERNAME}/widget/`;
export const bazaarMyTransactionsUrl = `/market/my_bazaar/${USERNAME}/buyers/`;
export const bazaarProductDetailUrl = `/market/${CATEGORY}/${PRODUCT_HASH}/${PRODUCT_SLUG}/`;
export const bazaarGridUrl = `/market/${filterParams}`;
export const bazaarWishlistInactiveUrl = `/market/wishlist/${USERNAME}/inactive/:page(${PAGE_SLUG}-\\d+)?/`;
export const bazaarWishlistUrl = `/market/wishlist/${USERNAME}/${filterParams}`;
export const bazaarShoppingUrl = `/market/shopping/${USERNAME}/`;
export const bazaarCreateProductUrl = `/market/edit/`;
export const bazaarEditProductUrl = `/market/edit/${CATEGORY}/${PRODUCT_HASH}/${PRODUCT_SLUG}/`;
export const bazaarWatchdogSettingsUrl = `/market/watchdog/settings/:token([0-9a-zA-Z-_]+:[0-9a-zA-Z-_]+:[0-9a-zA-Z-_]+)?/`;
export const bazaarLastProductNotFoundUrl = `/market/my_bazaar/edit-last-stroller-not-found/`;
